var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:1.2788;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st0{\r\n\t\tstroke-dasharray: 500;\r\n  \t\tstroke-dashoffset: 900;\r\n    \tanimation:fadeIn 1600ms 100ms cubic-bezier(0.075, 0.82, 0.165, 1) forwards;\r\n\t}\r\n\r\n\t@keyframes fadeIn {\r\n    \t0%{\r\n  \t\t\tstroke-dashoffset: 900;\r\n    \t}\r\n  \t\t100%{\r\n  \t\t\tstroke-dashoffset: 1000;\r\n    \t}\r\n\t}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8-1.4l6.4,3.7c0.8,0.5,1.3,1.3,1.3,2.2v6c0,0.9-0.5,1.8-1.3,2.2l-6.4,3.7c-0.8,0.4-1.8,0.4-2.5,0l-6.4-3.7 c-0.8-0.5-1.3-1.3-1.3-2.2v-6c0-0.9,0.5-1.8,1.3-2.2l6.4-3.7C7-1.8,8-1.8,8.8-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.8,3.7l7.1,3.8C7,7.9,8,7.9,8.7,7.5l7.1-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,8.1v8.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxMotion);
export default __webpack_public_path__ + "static/media/box_motion.89d11b90c683120ddd88cdcbfb92be76.svg";
export { ForwardRef as ReactComponent };